import { styled } from 'styled-components'

export const Divider = styled.div`
  background-color: ${({ theme, $color }) => theme.colors[$color]};
  height: ${({ $transparent }) => ($transparent ? 0 : '1px')};
  width: 100%;
  ${({ $margins }) => $margins}
`
